var r;!function(r){r.debug="debug",r.error="error",r.info="info",r.warn="warn"}(r||(r={}));export{r as LoggerLevel};
